if (!customElements.get('register-form')) {
  class RegisterForm extends HTMLElement {
    constructor() {
      super();
      this.init();
      if (this.ownerForm)
        this.ownerRegister();
      if (this.vetForm)
        this.vetRegister();
    }
    init () {
      this.vetForm = document.querySelector("[data-vet-registration] form");
      this.ownerForm = document.querySelector("[data-affiliate-registration] form");
    }

    addReCaptchaToken = (submitForm, requestName, callback) => {
      grecaptcha.execute(window.Shopify.recaptchaV3.siteKey, { action: requestName }).then(
        function (token) {
          let tokenInput = submitForm.querySelector("input[name=recaptcha-v3-token]");
          if (tokenInput instanceof HTMLElement)
            tokenInput.setAttribute("value", token);
          else {
            tokenInput = document.createElement("input");
            tokenInput.setAttribute("name", "recaptcha-v3-token");
            tokenInput.setAttribute("type", "hidden");
            tokenInput.setAttribute("value", token);
            submitForm.appendChild(tokenInput);
          }
          if (callback)
            callback();
        }
      );
    }

    ownerLogin () {
      this.addReCaptchaToken(this.ownerForm, "customer_login", () => {
        const formData = new FormData(this.ownerForm);
        const objectForm = {};
        formData.forEach(function(value, key){
          objectForm[key] = value;
        });
        const submitData = {
          "form_type": "customer_login",
          "customer[email]": objectForm["customer[email]"],
          "customer[password]": objectForm["customer[password]"],
          "utf8": objectForm["utf8"],
          "recaptcha-v3-token": objectForm["recaptcha-v3-token"],
        };
        fetch("/account/login", {
          method: "POST",
          body: JSON.stringify(submitData)
        }).catch((error) => {
          console.log("ERROR");
        });
      });
    }

    changeAddress (submitedForm, redirectUrl) {
      this.addReCaptchaToken(submitedForm, "customer_address", () => {
        const formData = new FormData(submitedForm);
        const objectForm = {};
        formData.forEach(function(value, key){
          objectForm[key] = value;
        });
        const addressData = {
          "form_type": "customer_address",
          "utf8": objectForm["utf8"],
          "address[first_name]": objectForm["customer[first_name]"],
          "address[last_name]": objectForm["customer[last_name]"],
          "address[company]": objectForm["address[company]"],
          "address[address1]": objectForm["address[address1]"],
          "address[address2]": objectForm["address[address2]"],
          "address[city]": objectForm["address[city]"],
          "address[zip]": objectForm["address[zip]"],
          "address[phone]": objectForm["address[phone]"],
          "address[default]": "1",
          "recaptcha-v3-token": objectForm["recaptcha-v3-token"],
        };
        if (objectForm["address[country]"])
          addressData["address[country]"] = objectForm["address[country]"];
        if (objectForm["address[province]"])
          addressData["address[province]"] = objectForm["address[province]"];

        const submitData = new FormData();
        for (let key in addressData) {
          submitData.append(key, addressData[key]);
        }
        fetch("/account/addresses", {
          method: "POST",
          body: submitData
        }).then(response => {
          window.location.replace(redirectUrl);
        }).catch((error) => {
          console.log("ERROR");
        });
      });
    }

    changeVetAddress (submitedForm, redirectUrl) {
      this.addReCaptchaToken(submitedForm, "customer_address", () => {
        const formData = new FormData(submitedForm);
        const objectForm = {};
        formData.forEach(function(value, key){
          objectForm[key] = value;
        });
        const addressData = {
          "form_type": "customer_address",
          "utf8": objectForm["utf8"],
          "address[first_name]": objectForm["customer[first_name]"],
          "address[last_name]": objectForm["customer[last_name]"],
          "address[company]": submitedForm.querySelector("[data-vet-clinic-name]").value,
          "address[address1]": submitedForm.querySelector("[data-vet-clinic-address]").value,
          "address[address2]": submitedForm.querySelector("[data-vet-clinic-address-2]").value,
          "address[city]": submitedForm.querySelector("[data-vet-clinic-city]").value,
          "address[zip]": submitedForm.querySelector("[data-vet-clinic-zipcode]").value,
          "address[phone]": submitedForm.querySelector("[data-vet-clinic-phone]").value,
          "address[default]": "1",
          "recaptcha-v3-token": objectForm["recaptcha-v3-token"],
        };
        if (submitedForm.querySelector("[data-vet-clinic-country]").value)
          addressData["address[country]"] = submitedForm.querySelector("[data-vet-clinic-country]").value;
        if (submitedForm.querySelector("[data-vet-clinic-state]").value)
          addressData["address[province]"] = submitedForm.querySelector("[data-vet-clinic-state]").value;

        const submitData = new FormData();
        for (let key in addressData) {
          submitData.append(key, addressData[key]);
        }
        fetch("/account/addresses", {
          method: "POST",
          body: submitData
        }).then(response => {
          window.location.replace(redirectUrl);
        }).catch((error) => {
          console.log("ERROR");
        });
      });
    }

    ownerRegister () {
      this.ownerForm.addEventListener("submit", (e) => {
        if (this.ownerForm.hasAttribute("onsubmit"))
          this.ownerForm.removeAttribute("onsubmit");
        e.preventDefault();

        const formType = this.ownerForm.querySelector("input[name=\"form_type\"]");
        let formTypeValue = "create_customer";
        if (formType)
          formTypeValue = formType.value;
        this.addReCaptchaToken(this.ownerForm, formTypeValue, () => {
          const actionUrl = this.ownerForm.getAttribute("action");
          const formData = new FormData(this.ownerForm);
          fetch(actionUrl, {
            method: "POST",
            body: formData
          }).then(response => {
            if (response.url.indexOf("/challenge") !== -1){
              window.location.replace(response.url);
            } else if (response.url.indexOf("/account/register") !== -1){
              this.ownerForm.submit();
            } else
              this.changeAddress(this.ownerForm, response.url);
          });
        });
      });
    }

    vetRegister () {
      this.vetForm.addEventListener("submit", (e) => {
        if (this.vetForm.hasAttribute("onsubmit"))
          this.vetForm.removeAttribute("onsubmit");
        e.preventDefault();
        const formType = this.vetForm.querySelector("input[name=\"form_type\"]");
        let formTypeValue = "create_customer";
        if (formType)
          formTypeValue = formType.value;
        this.addReCaptchaToken(this.vetForm, formTypeValue, () => {
          const actionUrl = this.vetForm.getAttribute("action");
          const formData = new FormData(this.vetForm);
          fetch(actionUrl, {
            method: "POST",
            body: formData
          }).then(response => {
            if (response.url.indexOf("/challenge") !== -1){
              window.location.replace(response.url);
            } else if (response.url.indexOf("/account/register") !== -1){
              this.vetForm.submit();
            } else
              this.changeVetAddress(this.vetForm, response.url);
          });
        });
      });
    }
  }
  customElements.define('register-form', RegisterForm);
}

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};

class CustomerAddresses {
  constructor() {
    this._setupCountries();
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }
  }

  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );
  }
}
